import React, { useState, useContext, useEffect } from 'react'
import { Input, Modal, Form, Select, Row, Col, Button } from 'antd'
import api from '../../../services/api'
import SL_Button from '../../../components/buttons/Button'
import GeneralContext from '../../../context/GeneralContext/GeneralContext'
import EUsersTypes from '../../../enums/EUsersTypes'
import { ERegExp } from '../../../enums/ERegExp'
import { SL_Date } from "../../../components/date/Date";
import { displayMessage } from '../../../helpers/messages'
import { phoneMask, phoneUnmask, cpfMask, cpfUnmask } from '../../../helpers/iMask'
import { MaskedInput } from 'antd-mask-input';

// const { Option } = Select
// var userTypeList = Object.values(EUsersTypes)
//     .filter(userType => userType.code < EUsersTypes.ORIGINAL_CLIENT.code)
//     .map(userType => {
//         return (
//             { value: userType.code, label: userType.title }
//         )
//     })
// const DATE_FORMAT = 'DD/MM/YYYY'


export default function CreateUser({ handleOnCloseModal, refreshUsers, clientsList, idClient }) {
    const [form] = Form.useForm()

    const {
        setShowLoading,
        mobile_mode,
    } = useContext(GeneralContext)

    // useEffect(() => {
    //     phoneMask('whatsapp-number')
    //     cpfMask('cpf-number')
    // }, [])


    const handleCreateUser = async (values) => {
        setShowLoading(true)
        try {
            let formatedValues = {
                ...values,
                // plan_expired: "2024-05-02",
                is_active: true,
                whatsapp: values.whatsapp ? phoneUnmask(values.whatsapp) : null,
                cpf: values.cpf ? cpfUnmask(values.cpf) : null,
            }
            console.log(formatedValues)
            await api.user.createAdmin(formatedValues)
            await refreshUsers()
            await handleOnCloseModal(true)
            alert(displayMessage('CREATE_USER_SUCCESS'), 'success', displayMessage('SUCCESS'))
        } finally {
            setShowLoading(false)
        }
    }

    return (
        <Modal
            title={<div className="text-xl font-bold text-fit-red-900">{displayMessage('REGISTER_USER_2')}</div>}
            open={true}
            onCancel={() => handleOnCloseModal(false)}
            centered={true}
            footer={
                <div className='flex justify-end'>
                    <SL_Button className="w-[150px] bg-gray-500 border-transparent" onClick={() => handleOnCloseModal(false)}>{displayMessage('CLOSE')}</SL_Button>

                    <SL_Button className="w-[150px]" onClick={() => form.submit()}>{displayMessage('END_REGISTER')}</SL_Button>
                </div>
            }
            maskClosable={false}
            width={750}
            bodyStyle={{ overflow: 'auto' }}
        >
            <Form
                onFinish={handleCreateUser}
                layout="vertical"
                requiredMark='optional'
                form={form}
            >
                <div style={{ display: 'flex', gap: 2, flexDirection: 'column', gap: 10 }}>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('FIRST_NAME')}:</span>}
                            name="first_name"
                            className={`w-full m-0`}
                            rules={[{ required: true, message: displayMessage('FIRST_NAME_MANDATORY'), pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: false }]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('LAST_NAME')}:</span>}
                            name="last_name"
                            className={`w-full m-0`}
                            rules={[
                                { pattern: ERegExp.MUST_HAVE_LETTERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }
                            ]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('PASSWORD')}:</span>}
                            name="password"
                            className={`w-full m-0`}
                            rules={[{ required: true, message: displayMessage('PASSWORD'), pattern: ERegExp.MUST_HAVE_LETTERS.regexp, whitespace: false }]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                    </div>
                    <div style={{ width: '100%', display: 'flex', flexDirection: mobile_mode ? 'column' : 'row', gap: 10 }}>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('EMAIL')}:</span>}
                            name="email"
                            className={`w-full m-0`}
                            rules={[
                                { required: true, type: 'email' },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') }]}
                            style={{ flex: 1 }}
                        >
                            <Input type="text" className='text-fit-red-900' />
                        </Form.Item>
                        <Form.Item
                            label={<span className='text-fit-red-900 font-semibold'>{displayMessage('CPF')}:</span>}
                            name="cpf"
                            className={`w-full m-0`}
                            rules={[
                                { required: true, message: displayMessage('CPF_MANDATORY') },
                                { pattern: ERegExp.MUST_HAVE_NUMBERS.regexp, message: displayMessage('INVALID_INPUT_DATA') },
                                { whitespace: false, message: displayMessage('NO_WHITE_SPACE_WARNING') },
                                { min: 14, message: displayMessage('CPF_DIGITS_WARNING') }
                            ]}
                            style={{ flex: 1 }}
                        >
                            {/* <Input type="text" className='text-fit-red-900' id='cpf-number' onChange={() => cpfMask('cpf-number')} /> */}
                            <MaskedInput mask='000.000.000-00' />
                        </Form.Item>

                        
                     
                    </div>
                   
                </div>
            </Form>
        </Modal>
    )
}
